<template>
  <div
    class="actions-content"
    :style="wrapperStyle"
  >
    <FilterRow
      label="FILTERS"
      :displayLimit="displayLimit"
      @add="$emit('add')"
      @complete="$emit('clearReport')"
    ></FilterRow>
    <DashboardCalendarPicker
      id="explorer-header-calendar"
      :value="localDateValue"
      :minDate="minDate"
      :maxDate="maxDate"
      @click="handleDateApply"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import DashboardCalendarPicker from '../Common/DashboardCalendarPicker.vue';
import FilterRow from '../Common/FilterRow.vue';

export default {
  props: {
    filters: {
      type: Array,
    },
    portfolioBrands: {
      type: Array,
    },
    dateValue: {
      type: Object,
    },
    minDate: {
      type: [Date, Number],
    },
    maxDate: {
      type: [Date, Number],
    },
    displayLimit: {
      type: Number,
      default: 2,
      validator: val => val > 0 && val <= 3,
    },
  },
  components: {
    DashboardCalendarPicker,
    FilterRow,
  },
  data() {
    return {
      localDateValue: this.dateValue,
    };
  },
  methods: {
    handleDateApply(value) {
      this.$emit('dateApply', value);
    },
  },
  watch: {
    dateValue() {
      this.localDateValue = this.dateValue;
    },
  },
  computed: {
    ...mapState({
      marginBehindNavBar: state => state.main.marginBehindNavBar,
    }),
    wrapperStyle() {
      return `width: calc(100vw - ${this.marginBehindNavBar + 48}px);`;
    },
  },
};
</script>
<style scoped>
.actions-content {
  width: 100vw;
  height: 68px;
  max-width: 1310px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.report-field-row {
  max-width: calc(100% - 350px);
}

.filters-beginning {
  font-family: Lato;
  font-size: 12px;
  line-height: 16.8px;
  color: #223448;
}

.extra-count {
  pointer-events: none;
}

.actions-container .extra-count button.secondary {
  background: #00A6A4;
}

.calendar-picker .date-range-control {
  cursor: pointer;
}

.calendar-picker-container {
  z-index: 2;
}

#explorer-header-calendar {
  width: 300px;
  height: 65%;
}
</style>
<style>
.actions-content .picker-container {
  right: 0;
}
</style>
